"use client";

function ArticleShare({ articleTitle, children }) {
  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: `${articleTitle} | Vijay Garg & Associates`,
          text: `Read our expert insights on "${articleTitle}" by Vijay Garg & Associates, Jaipur's trusted CA firm.`,
          url: window?.location?.href,
        });
      } catch (err) {
        console.error("Sharing failed:", err);
      }
    } else {
      alert("Sharing not supported on this device or browser.");
    }
  };

  return (
    <button onClick={handleNativeShare} className="cursor-pointer ">
      {children}
    </button>
  );
}

export default ArticleShare;
